// extracted by mini-css-extract-plugin
export default {"delete-channel-popup__content":"MultipleDeleteChannelPopup_delete-channel-popup__content__qsOYj"};